function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as e, jsxs as d } from "react/jsx-runtime";
import * as h from "react";
import c from "classnames";
import { Text1 as R, Text2 as x } from "./text.js";
import { useTheme as C, useScreenSize as F, useElementDimensions as P } from "./hooks.js";
import T from "./icons/icon-success.js";
import { stepper as k, vars as w, step as D, stepIconNumber as u, iconAnimation as j, number as z, currentNumber as B, textContainer as H, bar as $, barFilled as E, barFilledAnimation as L, barFilledReverseAnimation as M } from "./stepper.css-mistica.js";
import { pxToRem as O } from "./utils/css.js";
import { assignInlineVars as V } from "@vanilla-extract/dynamic";
import { vars as s } from "./skins/skin-contract.css-mistica.js";
import { getPrefixedDataAttributes as q } from "./utils/dom.js";
const G = (param)=>{
    let { steps: n , currentIndex: t , "aria-label": v , dataAttributes: f  } = param;
    const { textPresets: g  } = C(), { isDesktopOrBigger: b  } = F(), { height: N , ref: S  } = P(), A = N, l = h.useRef(t), i = l.current > t;
    return t !== l.current && (l.current = t), /* @__PURE__ */ e("div", _object_spread_props(_object_spread({
        className: k,
        style: V({
            [w.stepperMinHeight]: O(40 + A)
        })
    }, q(f, "Stepper")), {
        children: n.map((p, a)=>{
            const r = a === t, y = a === n.length - 1, o = a < t, m = a === t - 1;
            return /* @__PURE__ */ d(h.Fragment, {
                children: [
                    /* @__PURE__ */ d("div", {
                        className: D,
                        role: "progressbar",
                        "aria-valuenow": r ? a + 1 : void 0,
                        "aria-valuemin": 1,
                        "aria-valuemax": n.length,
                        "aria-valuetext": p,
                        "aria-label": v,
                        children: [
                            o ? /* @__PURE__ */ e("div", {
                                className: c(u, {
                                    [j]: m && !i
                                }),
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ e(T, {
                                    color: s.colors.controlActivated,
                                    size: "100%",
                                    skipAnimation: !m || i
                                })
                            }) : /* @__PURE__ */ e("div", {
                                className: c(u, z, {
                                    [B]: r || r
                                }),
                                children: /* @__PURE__ */ e(R, {
                                    as: "span",
                                    weight: g.indicator.weight,
                                    color: r ? s.colors.textPrimaryInverse : s.colors.textSecondary,
                                    "aria-hidden": "true",
                                    children: a + 1
                                })
                            }),
                            b && /* @__PURE__ */ e("div", {
                                className: H,
                                ref: S,
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ e(x, {
                                    as: "span",
                                    regular: !0,
                                    color: o || r ? s.colors.textPrimary : s.colors.textSecondary,
                                    children: p
                                })
                            })
                        ]
                    }),
                    !y && /* @__PURE__ */ e("div", {
                        className: $,
                        "aria-hidden": "true",
                        children: (o || r) && /* @__PURE__ */ e("div", {
                            className: c({
                                [E]: i && r || o,
                                [L]: m && !i,
                                [M]: r && i
                            })
                        })
                    })
                ]
            }, a);
        })
    }));
}, ee = G;
export { ee as default };
